export const THEME_MODE = {
  dark: 'dark',
  light: 'light',
  system: 'system',
}

export const THEME_MODE_DEFAULT = THEME_MODE.light

export const THEME = {
  dark: 'dark',
  light: 'light',
}

export const THEME_DARK_MEDIA_QUERY = '(prefers-color-scheme: dark)'

export const THEME_LIGHT_ONLY_PAGE_REG_EXP =
  /\/mails\/(message|thread)\/[^/]+\/(raw|print)\/?$/

// Mirror the dark block of tokens.css: the color math needs values, not CSS variables
export const THEME_DARK_SURFACE_COLOR = '#1b1f2b'

export const THEME_DARK_RAISED_COLOR = '#222634'

export const THEME_DARK_LINE_COLOR = '#2c3140'

export const THEME_DARK_TEXT_COLOR = '#e6e9f2'

export const THEME_DARK_TEXT_CONTRAST = 4.5

export const THEME_DARK_LIGHT_HEADER_LUMINANCE = 0.5

export const THEME_DARK_READABLE_STEP = 2

export const THEME_DARK_READABLE_MAX_STEPS = 50

export const THEME_DARK_READABLE_ADJUSTMENT = {
  darken: 'darken',
  lighten: 'lighten',
}

export const THEME_DARK_TINT_MIX = {
  deactiveButtonBg: 22,
  deactiveButtonText: 56,
  selectedElementBg: 48,
  submenuButtonBg: 36,
  submenuHover: 14,
}

export const THEME_DARK_PRESSED_SURFACE_MIX = 20

export const THEME_DARK_ON_ACCENT_TEXT_COLOR = {
  dark: THEME_DARK_SURFACE_COLOR,
  light: '#fff',
}

export const THEME_DARK_CONTENT_LIGHT_BACKGROUND_LUMINANCE = 0.5

export const THEME_DARK_CONTENT_NEUTRAL_SATURATION = 0.15

export const THEME_DARK_CONTENT_NEUTRAL_LIFT_MIX = 60

export const THEME_DARK_CONTENT_TINT_SATURATION = 0.6

export const THEME_DARK_CONTENT_TINT_LIGHTNESS = { max: 0.25, min: 0.14 }

export const THEME_CONTENT_SEE_THROUGH_BACKGROUNDS = [
  'currentcolor',
  'inherit',
  'initial',
  'none',
  'revert',
  'transparent',
  'unset',
]

export const THEME_CONTENT_BACKGROUND_IMAGE_REG_EXP = /url\(|gradient\(/i

export const THEME_CONTENT_PAPER_COLOR = {
  background: '#fff',
  text: '#242f57',
}

export const THEME_CONTENT_ORIGINAL_STYLE_ATTRIBUTE = 'data-original-style'

export const THEME_CONTENT_CORRECTED_PROPERTIES = ['background-color', 'color']

export const THEME_CONTENT_CORRECTION_KEY_SEPARATOR = '|'

export const THEME_CONTENT_IMPORTANT_SUFFIX_REG_EXP = /\s*!\s*important\s*$/i

export const THEME_CONTENT_IMPORTANT_PRIORITY = 'important'
